import BdMap from './bd-map.vue'
export default BdMap
